<template>
  <section v-if="glowTagProduct">
    <h2 class="mb-2">{{ $t('otherProductSelect.glowTag.title') }}</h2>
    <b-row>
      <b-col cols="4">
        <b-img
          v-if="!glowTagProductOutOfStock"
          :src="require('@/assets/images/glow-tag.jpg')"
          fluid
          center
          class="glow-tag-img"
          alt=""
        />
        <div v-else class="no-stock">
          <b-img :src="require('@/assets/images/glow-tag.jpg')" fluid center class="glow-tag-img" alt="" />
          <svg aria-hidden="true"><line x1="0" y1="100%" x2="100%" y2="0" /></svg>
        </div>
      </b-col>
      <b-col cols="8">
        <div>
          <h3 class="text-dark">{{ $t('otherProductSelect.glowTag.description') }}</h3>
          <b-checkbox
            v-show="!glowTagProductOutOfStock"
            id="product-style-glow-tag"
            :checked="glowTagProductQuantity"
            value="1"
            unchecked-value="0"
            size="lg"
            class="other-product-checkbox"
            :disabled="glowTagProductOutOfStock"
            @change="setOtherProduct"
          >
            <h3 class="pt-1" :class="glowTagProductQuantity !== 1 ? 'text-dark' : 'text-primary'">
              {{ $t('otherProductSelect.glowTag.text.1', [Number(glowTagProduct.price).toFixed(2)]) }}
            </h3>
          </b-checkbox>
          <b-checkbox
            v-show="!glowTagProductOutOfStock"
            :checked="glowTagProductQuantity"
            value="2"
            unchecked-value="0"
            size="lg"
            class="other-product-checkbox"
            :disabled="glowTagProductOutOfStock"
            @change="setOtherProduct"
          >
            <p class="pt-1 h3" :class="glowTagProductQuantity !== 2 ? 'text-dark' : 'text-primary'">
              {{
                $t('otherProductSelect.glowTag.text.2', [
                  ((Number(glowTagProduct.discountedPrice) || Number(glowTagProduct.price)) * 2).toFixed(2),
                ])
              }}
            </p>
          </b-checkbox>
          <div v-show="glowTagProductOutOfStock" class="text-danger copy" v-text="$t('product.outOfStock')" />
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'GlowTagProductSelect',
  props: {
    value: {
      type: Number,
      required: false,
      default: 0,
    },
    glowTagProductId: {
      type: String,
      required: false,
      default: '3284',
    },
  },
  data() {
    return {
      glowTagProductQuantity: this.value,
    };
  },
  computed: {
    ...mapState('otherProduct', ['glowTagProducts']),
    glowTagProduct() {
      return this.glowTagProducts?.[`Product_${this.glowTagProductId ?? '3284'}`];
    },
    glowTagProductOutOfStock() {
      return this.glowTagProduct?.status === 'O';
    },
  },
  methods: {
    setOtherProduct(quantity) {
      this.glowTagProductQuantity = Number(quantity);
      this.$emit('input', this.glowTagProductQuantity);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.glow-tag-img {
  border-radius: 10px;
  border: 2px solid $dp-gray-4;
  height: auto;
  width: 100%;
}
.no-stock {
  position: relative;
  img {
    width: 100%;
    filter: grayscale(80%);
  }
  svg {
    width: 90%;
    height: 90%;
    position: absolute;
    top: 5%;
    left: 5%;
    line {
      stroke: $dp-gray-5;
      stroke-width: 4;
    }
  }
}
</style>
